import { Dispatch } from "redux";
import {
  getCountriesPending,
  getCountriesSuccess,
  getCountriesError,
  getRegionsPending,
  getRegionsSuccess,
  getRegionsError,
} from "../actions/internationalize";

import { Internationalize } from "../../lib/qc-api-client";

export const getCountries = () => {
  return (dispatch: Dispatch) => {
    dispatch(getCountriesPending());
    Internationalize.countries()
      .then((response: any) => dispatch(getCountriesSuccess(response.data)))
      .catch((error: any) => dispatch(getCountriesError(error)));
  };
};

export const getRegions = (code: string) => {
  return (dispatch: Dispatch) => {
    dispatch(getRegionsPending());
    Internationalize.regions(code)
      .then((response: any) => dispatch(getRegionsSuccess(response.data)))
      .catch((error: any) => dispatch(getRegionsError(error)));
  };
};
